import { createApp } from 'vue'
import { Toast } from 'vant'
import { ReconnectionTimeMode } from '@stomp/stompjs'
import { Auth, Device, Mfe, globalConfig, Url, PWsStomp } from '@nio-pow/mfe-vue3'
import Analytics from '@/core/Analytics'
import CopyMonitor from '@/core/CopyMonitor'
import { startMonitor } from '@/core/Analytics/performance'
import  {startWhiteScreenDetector } from '@/core/WhiteScreenDetector'
import { fetchBackend } from '@/utils/fetch'
import App from './App.vue'
import { genRouter } from './router'
import startMfe from './mfe'
import i18n, { t } from './i18n'

import { NioApmPlus } from '@nio-fe/nio-apm-plus'
import { addGlobalUncaughtErrorHandler } from 'qiankun'
import '@/core/hack'
// vant 按需加载后，toast 样式需要单独引入
import 'vant/es/toast/style'
// cedar 暂不支持按需加载 css
import '@nio-pow/cedar-design-web/dist/index.css'
import { AUTH_WHITELIST } from './utils/constants'

// 初始化 sdk 内的 fetch 函数
globalConfig.fetch = fetchBackend

// 初始化 url 中携带的 accessToken
Auth.initAccessToken()
// addGlobalUncaughtErrorHandler((err) => {
//   console.error('【qiankun 全局错误】', err)

//   NioApmPlus.getDefaultInstance()?.captureException?.(err)
// })

export async function renderApp() {
  // 初始化埋点统计
  Analytics.init({ enableXHRMonitor: true })

  // 性能统计
  startMonitor()

  // 开启白屏检测
  startWhiteScreenDetector()

  let userRes: any
  if (!AUTH_WHITELIST.includes(window.location.pathname)) {
    console.log('current pathname', window.location.pathname)
    console.log('AUTH_WHITELIST', AUTH_WHITELIST)
    Toast.loading({
      message: t('loading') as string,
      forbidClick: true,
      duration: 10000,
    })

    const curWin = window as any
    curWin.mainAppToast = Toast

    // 若 url 中存在 token，则进行 jwt 登录流程
    await Auth.checkLogin()

    const ifErrorPage = window.location.pathname === '/error'
    // 若为跳转登录成功后返回，则回到登录前的页面
    if (!ifErrorPage) Url.redirecToFullpathAfterLogin('history')

    // 初始化用户信息等数据
    userRes = await Auth.initUserInfoWithCacheMode()

    // 判定是否继续加载后续页面
    if (
      (!ifErrorPage && userRes.resultCode === 'user_no_login') ||
      userRes.resultCode === 'auth_failed'
    ) {
      return
    }

    // 连接ws需要token，故要在登录后。
    try {
      // 创建客户端并启动连接
      PWsStomp.startClient({
        // 设置默认url，这样子应用订阅时就不用传url了
        // defaultUrl: 'http://localhost:1128/pe/dingdong/ws?ws_token=' + Auth.getAccessToken(),
        defaultUrl: `${window.location.protocol}//${window.location.host}/pe/dingdong/ws?ws_token=${Auth.getAccessToken()}`,
        // 挂载全局方法到全局window，供子应用使用
        setStoreToGlobal: true,
        stompConfig: {
          reconnectDelay: 5000, // 重连延迟
          maxReconnectDelay: 30000, // 最大重连延迟
          reconnectTimeMode: ReconnectionTimeMode.EXPONENTIAL // 重连时间模式，重连的时间间隔会指数增长至最大重连延迟
        }

      })
      console.log('ws初始化成功')
    } catch (e) {
      console.log('ws初始化失败', e)
    }

    // 全局复制监听（由于内部有接口调用，可能会触发登录逻辑，因此放到此位置）。user/info接口必须是第一个调用的接口
    CopyMonitor.start()

    // 获取 user id 并进行埋点用户绑定
    try {
      const { userId } = userRes?.data || {}
      Analytics.login(userId)
    } catch {}
  }

  // 渲染页面
  const router = genRouter()
  const app = createApp(App)
  
  if(!AUTH_WHITELIST.includes(window.location.pathname)) {
    // 启用火山引擎的错误日志上报收集
    // await Mfe.Apm.start(app)
  }

  app.use(i18n).use(router).mount('#app')
  app.config.compilerOptions.isCustomElement = (tag) => {
    return ['pg-icon'].includes(tag)
  }

  // 开启微前端子应用渲染
  startMfe()

  // 主应用自有路由（如 /assistant）不经过子应用挂载生命周期，
  // 启动 loading 不会被子应用 beforeMount 的 Toast.clear() 关闭，这里补齐
  if (!Mfe.findMicroApp(window.location.pathname)) {
    Toast.clear()
  }
  // 在飞书外访问时，主动添加水印
  // if (!Device.isFeishu()) {
  //   import('watermark-dom').then(({ watermark }) => {
  //     const { userId } = userRes?.data || {}
  //     // 添加水印的第一行文字
  //     if (userId) watermark.init({ watermark_txt: userId })
  //   })
  // }
}
